// extracted by mini-css-extract-plugin
module.exports = {"buttons":"editDialog_buttons_-Md2o"};